import React, { Component } from "react";
import wise_icon from "../../../images/bank-ac.png";
import w9_icon from "../../../images/tax.png";

class WiseW9ReportRow extends Component {
    constructor(props) {
        super(props);
        this.state = {
        };
    }

    render() {
        const { email, fullName, phone, userName, userType, w9Info, accountInfo } = this.props;

        return (
            <div className="table_row user_page user_data main_data w9adminreportrow">
                {email ? (
                    <div
                    //onClick={this.props.toggle_report_details_popup}
                    >
                        <div>{userName}</div>
                        <div>{fullName}</div>
                        <div>{email}</div>
                        <div>{phone}</div>
                        <div>{userType}</div>
                        {accountInfo?.accountType ? <div className="icon account-icon">
                            <i className="tooltip" tabIndex="0"><img src={wise_icon} width="30" alt="wise" /><span>
                                Acc Summary: {accountInfo?.accSummary || "N/A"} <br />
                                Long Summary: {accountInfo?.longAccSummary || "N/A"} <br />
                                Account Type: {accountInfo?.accountType || "N/A"} <br />
                                Wise User Id: {accountInfo?.wiseUserId || "N/A"} <br />
                                Bank: {accountInfo?.bankName || "N/A"} <br />
                                Submission Date: {accountInfo?.wiseSubmitionDate || "N/A"}
                            </span></i>
                        </div> : <div className="icon account-icon">N/A</div>}
                        {w9Info?.signed_Date ? <div className="icon w9-icon">
                            <i className="tooltip" tabIndex="0"><img src={w9_icon} width="30" alt="w9" /><span>
                                Signed Date: {w9Info?.signed_Date || "N/A"} <br />
                                Business Classification: {w9Info?.businessClassification || "N/A"} <br />
                                Entry Status: {w9Info?.entryStatus || "N/A"} <br />
                                TIN: {w9Info?.tin || "N/A"} <br />
                                Full Address: {w9Info?.fullAddress || "N/A"}
                            </span></i>
                        </div> : <div className="icon w9-icon">N/A</div>}
                    </div>
                ) : (
                    <div>
                        <div className="no_record_found">No Record Found</div>
                    </div>
                )}
            </div>
        );
    }
}

export default WiseW9ReportRow;